<div>
  <p [class]="'col-4 mb-2 w-100 ' + headerClass">Custom Regulatory Standards</p>
  <div class="w-100">
    <ng-select [formControl]="control" name="orgStandards" id="orgStandards"
      [items]="enabledOrgStandards" bindLabel="name" bindValue="standardID" [multiple]="true"
      [selectableGroup]="true" [searchable]="true" [selectableGroupAsModel]="false"
      [closeOnSelect]="false" [clearSearchOnAdd]="true" groupBy="frameworkName" [virtualScroll]="true">
      <ng-template ng-optgroup-tmp let-item="item">
          {{ item.frameworkName }}
      </ng-template>
      <ng-template ng-header-tmp>
          <div class="d-flex justify-content-between">
              <button class="btn btn-link" (click)="onClearAllOrgStandards()">Clear All
              </button>
          </div>
      </ng-template>
      <ng-template let-items="items" let-clear="clear" ng-multi-label-tmp>
          <div class="ng-value" *ngFor="let item of getEnabledOrgStandards(items)">
            <span class="ng-value-label">{{ item.name }}</span>
            <span class="ng-value-icon right" (click)="clear(item)">×</span>
          </div>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <div class="custom-control custom-checkbox" [ngClass]="{'ms-6' : item.child}">
              <input id="org-standard-item-{{index}}" class="custom-control-input"
                  type="checkbox" [ngModel]="item$.selected"
                  [ngModelOptions]="{standalone: true}" />
              <label class="custom-control-label mb-0 f-small text-neutral-800">{{item.name}}</label>
          </div>
      </ng-template>
    </ng-select>
  </div>
</div>
